/** Collect image URL strings from assorted product / visit shapes. */
function productImageUrls(product) {
  if (!product || typeof product !== 'object') return [];
  const urls = [];
  const push = (v) => {
    if (typeof v === 'string' && v.trim()) urls.push(v.trim());
    else if (v && typeof v === 'object' && typeof v.url === 'string' && v.url.trim()) {
      urls.push(v.url.trim());
    }
  };
  push(product.image);
  push(product.thumbnail);
  push(product.coverImage);
  if (Array.isArray(product.images)) product.images.forEach(push);
  return urls;
}

function hasMongoId(product) {
  const candidates = [product._id, product.id, product.productId];
  return candidates.some((id) => id != null && /^[a-f0-9]{24}$/i.test(String(id).trim()));
}

/**
 * True for legacy `src/data/products.js` rows and other placeholder catalog items.
 * Real API products use MongoDB ObjectIds and Cloudinary (not picsum).
 */
export function isDemoProduct(product) {
  if (!product || typeof product !== 'object') return true;

  if (hasMongoId(product)) {
    const urls = productImageUrls(product);
    if (urls.length > 0 && urls.every((u) => /picsum\.photos/i.test(u))) return true;
    return false;
  }

  const urls = productImageUrls(product);
  if (
    urls.some((u) =>
      /picsum\.photos|placehold\.co|via\.placeholder|placeholder\.com|dummyimage|loremflickr|placekitten|unsplash\.it/i.test(
        u
      )
    )
  ) {
    return true;
  }

  const legacyId = product.id ?? product.productId;
  if (legacyId != null && /^\d+$/.test(String(legacyId).trim())) return true;

  const urlSlug = product.url;
  if (typeof urlSlug === 'string' && /^\d{6}w\d{6}$/i.test(urlSlug.trim())) return true;

  return false;
}

export function filterRealProducts(list) {
  if (!Array.isArray(list)) return [];
  return list.filter((p) => p && !isDemoProduct(p));
}

/** Storefront grids (PDP “You May Also Like”, etc.) — real API catalog only. */
export function isCatalogProductForDisplay(product) {
  return !isDemoProduct(product) && hasMongoId(product);
}

export function filterCatalogProducts(list) {
  if (!Array.isArray(list)) return [];
  return list.filter((p) => isCatalogProductForDisplay(p));
}
